import CampaignsPage from '@/modules/campaigns/pages/CampaignsPage'
import CampaignLogPage from '@/modules/campaigns/pages/CampaignLogPage'
import CampaignExecutionsPage from '@/modules/campaigns/pages/CampaignExecutionsPage'
import CampaignTriggersPage from '@/modules/campaigns/pages/CampaignTriggersPage'
import CampaignQualificationsPage from '@/modules/campaigns/pages/CampaignQualificationsPage'
import AllCampaignsTab from '@/modules/campaigns/components/AllCampaignsTab'
import ScheduledCampaignsTab from '@/modules/campaigns/components/ScheduledCampaignsTab'
import LiveCampaignsTab from '@/modules/campaigns/components/LiveCampaignsTab'
import PastCampaignsTab from '@/modules/campaigns/components/PastCampaignsTab'
import DraftCampaignsTab from '@/modules/campaigns/components/DraftCampaignsTab'
import ApproveCampaignsPage from '@/modules/campaigns/pages/ApproveCampaignsPage'
import TemplateCampaignsPage from '@/modules/campaigns/pages/TemplateCampaignsPage'
import TemplateCampaignsTab from '@/modules/campaigns/components/TemplateCampaignsTab'
import PreMadeTemplatesTab from '@/modules/campaigns/components/PreMadeTemplatesTab'
import EngagementCategoriesPage from '@/modules/campaigns/pages/EngagementCategoriesPage'
import EngagementCategoriesTab from '@/modules/campaigns/components/EngagementCategoriesTab'
import EngagementCategoriesFormPage from '@/modules/campaigns/components/EngagementCategoriesFormPage'

export default [
  {
    name: 'Campaigns',
    path: '/push/campaign',
    component: CampaignsPage,
    meta: {
      auth: ['viewProjectItem'],
      title: 'LeftNavigation_Campaigns'
    },
    children: [
      {
        name: 'AllCampaignsTab',
        path: '/push/campaign/index',
        component: AllCampaignsTab,
        project: true,
        meta: {
          auth: ['viewProjectItem'],
          title: 'CampaignsPage_Title_All'
        }
      },
      {
        name: 'ScheduledCampaignsTab',
        path: '/push/campaign/scheduled',
        component: ScheduledCampaignsTab,
        project: true,
        meta: {
          auth: ['viewProjectItem'],
          title: 'CampaignsPage_Title_Scheduled'
        }
      },
      {
        name: 'LiveCampaignsTab',
        path: '/push/campaign/active',
        component: LiveCampaignsTab,
        project: true,
        meta: {
          auth: ['viewProjectItem'],
          title: 'CampaignsPage_Title_Live'
        }
      },
      {
        name: 'PastCampaignsTab',
        path: '/push/campaign/past',
        component: PastCampaignsTab,
        project: true,
        meta: {
          auth: ['viewProjectItem'],
          title: 'CampaignsPage_Title_Past'
        }
      },
      {
        name: 'DraftCampaignsTab',
        path: '/push/campaign/drafts',
        component: DraftCampaignsTab,
        project: true,
        meta: {
          auth: ['viewProjectItem'],
          title: 'CampaignsPage_Title_Drafts'
        }
      }
    ]
  },
  {
    path: '/push/campaign/log',
    component: CampaignLogPage,
    meta: {
      auth: ['viewProjectItem']
    },
    children: [
      {
        name: 'CampaignExecutions',
        path: 'executions',
        component: CampaignExecutionsPage,
        meta: {
          auth: ['viewProjectItem']
        }
      },
      {
        name: 'CampaignTriggers',
        path: 'triggers',
        component: CampaignTriggersPage,
        meta: {
          auth: ['viewProjectItem']
        }
      },
      {
        name: 'CampaignQualifications',
        path: 'qualifications',
        component: CampaignQualificationsPage,
        meta: {
          auth: ['viewProjectItem']
        }
      }
    ]
  },
  {
    name: 'ApproveCampaign',
    path: '/push/campaign/approve',
    component: ApproveCampaignsPage,
    meta: {
      auth: ['sendPushCampaign']
    }
  },
  {
    name: 'TemplateCampaigns',
    path: '/push/campaign/templates',
    component: TemplateCampaignsPage,
    meta: {
      auth: ['viewProjectItem']
    },
    children: [
      {
        name: 'TemplateCampaignsTab',
        path: '/push/campaign/templates/index',
        component: TemplateCampaignsTab,
        project: true,
        meta: {
          auth: ['createProjectItem'],
          title: 'Template_CampaignsPage_Title'
        }
      },
      {
        name: 'PreMadeTemplatesTab',
        path: '/push/campaign/templates/pre-made',
        component: PreMadeTemplatesTab,
        project: true,
        meta: {
          auth: ['createProjectItem'],
          title: 'Template_CampaignsPage_Title'
        }
      }
    ]
  },
  {
    name: 'EngagementCategories',
    path: '/push/campaign/engagement-categories',
    component: EngagementCategoriesPage,
    meta: {
      auth: ['viewProjectItem']
    },
    children: [
      {
        name: 'EngagementCategoriesTab',
        path: '/push/campaign/engagement-categories/index',
        component: EngagementCategoriesTab,
        project: true,
        meta: {
          auth: ['viewProjectItem'],
          title: 'LeftNavigation_EngagementCategories'
        }
      }
    ]
  },
  {
    name: 'EngagementCategoryUpdate',
    path: '/push/campaign/engagement-categories/update',
    component: EngagementCategoriesFormPage,
    project: true,
    meta: {
      auth: ['updateProjectItem'],
      title: 'LeftNavigation_EngagementCategories'
    }
  },
  {
    name: 'EngagementCategoryCreate',
    path: '/push/campaign/engagement-categories/create',
    component: EngagementCategoriesFormPage,
    project: true,
    meta: {
      auth: ['createProjectItem'],
      title: 'LeftNavigation_EngagementCategories'
    }
  },
  {
    name: 'EngagementCategoryView',
    path: '/push/campaign/engagement-categories/view',
    component: EngagementCategoriesFormPage,
    project: true,
    meta: {
      auth: ['viewProjectItem'],
      title: 'LeftNavigation_EngagementCategories'
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/campaigns/router/index.js